import * as moment from "moment";

import { ClientScheduleType } from "utils/transformApiSchedule";

import { generateWeeklyDates } from "./utils";

interface ScheduleType extends Pick<ClientScheduleType, "firstPayment"> {
  fallback?: Date[];
}

export default function biWeeklySampleDates(schedule: ScheduleType): Date[] {
  const defaultFallback = generateWeeklyDates(1);
  const { fallback = defaultFallback, firstPayment } = schedule;

  if (!firstPayment) return fallback;

  return [
    firstPayment,
    moment(firstPayment)
      .add({ weeks: 2 })
      .toDate(),
    moment(firstPayment)
      .add({ weeks: 4 })
      .toDate(),
  ];
}
